import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ScoreGauge, RiskBadge } from './ScoreGauge';

function getDomain(url) {
  try { return new URL(url).hostname.replace('www.', ''); } catch { return null; }
}

function LogoImg({ src, name, size = 36 }) {
  const [hasError, setHasError] = useState(false);
  const initials = (name || '?').split(/[\s-]+/).map(w => w[0]).join('').toUpperCase().slice(0, 2);

  if (!src || hasError) {
    return (
      <div style={{ width: size, height: size, borderRadius: 8, background: 'linear-gradient(135deg, #2E75B6, #5A2CA0)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white',
        fontWeight: 700, fontSize: size * 0.38, flexShrink: 0 }}>
        {initials}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={name}
      style={{ width: size, height: size, borderRadius: 8, objectFit: 'contain', background: 'white', border: '1px solid #eee', flexShrink: 0 }}
      onError={() => setHasError(true)}
      referrerPolicy="no-referrer"
    />
  );
}

export { LogoImg, getDomain };

export default function StartupCard({ startup, noBorder }) {
  const navigate = useNavigate();

  return (
    <div className={noBorder ? '' : 'startup-card'} onClick={() => navigate(`/startup/${startup.id}`)}
      style={{ fontSize: 11, padding: 20, cursor: 'pointer', ...(noBorder ? {} : {}) }}>
      <div className="startup-card-header">
        <div style={{ display: 'flex', gap: 10, alignItems: 'center', flex: 1, minWidth: 0 }}>
          <LogoImg src={startup.logo_url} name={startup.name} size={36} />
          <div style={{ minWidth: 0, flex: 1 }}>
            <h3 style={{ fontSize: 13, marginBottom: 2, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{startup.name}</h3>
            <div style={{ fontSize: 10, opacity: 0.85, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              {startup.sous_domaine || startup.categorie}
            </div>
          </div>
        </div>
        <ScoreGauge score={startup.note_sectorielle} />
      </div>
      <div className="startup-card-body">
        <div className="startup-card-meta" style={{ gap: 4, marginTop: 6, display: 'flex', flexWrap: 'wrap' }}>
          <RiskBadge level={startup.risk_level} />
          {startup.categorie && <span className="badge badge-secteur" style={{ fontSize: 9, padding: '2px 8px' }}>{startup.categorie}</span>}
          {startup.adressage_client && <span className="badge badge-client" style={{ fontSize: 9, padding: '2px 8px' }}>{startup.adressage_client}</span>}
          {startup.ca && <span className="badge" style={{ background: '#F0F0F0', color: '#555', fontSize: 9, padding: '2px 8px' }}>CA: {startup.ca}</span>}
          {startup.round_levee != null && <span className="badge" style={{ background: '#FFF8E1', color: '#F57F17', fontSize: 9, padding: '2px 8px' }}>Round {startup.round_levee}</span>}
          {startup.bodacc_count > 0 && (
            <span className="badge" style={{ background: '#E3F2FD', color: '#1565C0', fontSize: 9, padding: '2px 8px' }}
              title="Annonces BODACC disponibles">
              BODACC ({startup.bodacc_count})
            </span>
          )}
        </div>
        {startup.pitch && (
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 9, fontWeight: 600, color: 'var(--text-light)', textTransform: 'uppercase', marginBottom: 3 }}>Présentation</div>
            <p style={{ fontSize: 10, color: 'var(--text-muted)', lineHeight: 1.5, margin: 0,
              overflow: 'hidden', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
              {startup.pitch}
            </p>
          </div>
        )}
        {startup.top_force && (
          <div style={{ marginTop: 8, fontSize: 9 }}>
            <span style={{ color: '#27AE60' }}>Top: {startup.top_force}</span>
            {startup.top_faiblesse && (
              <span style={{ color: '#E74C3C', marginLeft: 12 }}>Faiblesse: {startup.top_faiblesse}</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
